module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_grzanie_3.08280ee1.svg";